import barba from '@barba/core';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);



function moduleAnimations()
{
    // Case Study Introduction
    const caseStudyIntroItems = document.querySelectorAll('.caseStudyIntroduction');

    if (caseStudyIntroItems.length > 0)
    {
        [...caseStudyIntroItems].forEach((element, index) => {
            const caseStudyIntroductionTitle = element.querySelector('.caseStudyIntroduction__title');
            const caseStudyClient = element.querySelector('.caseStudyIntroduction__client');
            const caseStudyIntroduction = element.querySelector('.caseStudyIntroduction__introduction');
            const caseStudyServicesElements = element.querySelectorAll('.caseStudyIntroduction__services .tag');
    
            caseStudyIntroductionTitle.split = new SplitText(caseStudyIntroductionTitle, { 
                type: "words,chars",
                wordsClass: "split-word",
                charsClass: "split-char"
            });
    
            gsap.set(caseStudyIntroductionTitle, {opacity: 1});
            gsap.set(caseStudyIntroductionTitle.split.chars, {x: "-1.5vw"});
    
            ScrollTrigger.create({
                trigger: element,
                start: "top 70%",
                onEnter: () => {
                    gsap.to(caseStudyIntroductionTitle.split.chars, { delay: 0.2, duration: 0.4, opacity: 1, x: "0vw", ease: "back.out(2)", stagger: { from: "start", each: 0.02}});
                    gsap.to(caseStudyClient, { opacity: 1, duration: 0.8, delay: 0.5 });
                    gsap.to(caseStudyServicesElements, { opacity: 1, x: 0, duration: 0.4, delay: 0.9, stagger:0.05 });
                    gsap.to(caseStudyIntroduction, { opacity: 1, duration: 0.8, delay: 1.2 });
                }
            });
        });
    }


    // Cover Image
    const coverImageItems = document.querySelectorAll('.coverImage');

    if (coverImageItems.length > 0)
    {
        [...coverImageItems].forEach((element, index) => {
            gsap.set(element, { opacity: 0 });
            gsap.fromTo(element, { opacity: 0 },
                {
                    delay: 0.5,
                    opacity: 1,
                    ease: "power2.out",
                    duration: 1.4,
                    scrollTrigger: 
                    {
                        trigger: element,
                        start: "top 70%",
                        scrub: false,
                        invalidateOnRefresh: true,
                        markers: false
                    }
                }
            );
        });
    }


    // Gallery Wall
    const galleryWallItems = document.querySelectorAll('.galleryWall__grid');

    if (galleryWallItems.length > 0)
    {
        [...galleryWallItems].forEach((element, index) => {
            const galleryItems = element.querySelectorAll('.galleryWall__item');
    
            gsap.set(galleryItems, { opacity: 0, y: 100 });
            gsap.fromTo(galleryItems, { opacity: 0, y: 100 },
                {
                    opacity: 1,
                    y: 0,
                    ease: "power2.out",
                    duration: 0.8,
                    stagger: 0.1,
                    scrollTrigger: 
                    {
                        trigger: element,
                        start: "top 70%",
                        scrub: false,
                        invalidateOnRefresh: true,
                        markers: false
                    }
                }
            );
        });
    }


    // Image Grid
    const imageGridItems = document.querySelectorAll('.imageGrid');

    if (imageGridItems.length > 0)
    {
        [...imageGridItems].forEach((element, index) => {
            const imageItems = element.querySelectorAll('.imageGrid__item');
    
            gsap.set(imageItems, { opacity: 0, y: 100 });
            gsap.fromTo(imageItems, { opacity: 0, y: 100 },
                {
                    opacity: 1,
                    y: 0,
                    ease: "power2.out",
                    duration: 0.6,
                    stagger: 0.05,
                    scrollTrigger: 
                    {
                        trigger: element,
                        start: "top 70%",
                        scrub: false,
                        invalidateOnRefresh: true,
                        markers: false
                    }
                }
            );
        });
    }


    // Service Introduction
    const serviceIntroItems = document.querySelectorAll('.serviceIntroduction');

    if (serviceIntroItems.length > 0)
    {
        [...serviceIntroItems].forEach((element, index) => {
            const serviceIntroductionTitle = element.querySelector('.serviceIntroduction__title');
            const servicesElements = element.querySelectorAll('.serviceIntroduction__services .discreetTag');
            const serviceIntroduction = element.querySelector('.serviceIntroduction__introduction');
    
            serviceIntroductionTitle.split = new SplitText(serviceIntroductionTitle, { 
                type: "words,chars",
                wordsClass: "split-word",
                charsClass: "split-char"
            });
    
            gsap.set(serviceIntroductionTitle, {opacity: 1});
            gsap.set(serviceIntroductionTitle.split.chars, {x: "-1.5vw"});
    
            gsap.to(serviceIntroductionTitle.split.chars, { delay: 0.5, duration: 0.5, opacity: 1, x: "0vw", ease: "back.out(2)", stagger: { from: "start", each: 0.025}});
    
            if (servicesElements.length > 0)
            {
                gsap.to(servicesElements, { opacity: 1, y: 0, duration: 0.4, delay: 0.8, stagger:0.05 });
            }
    
            if (serviceIntroduction != null)
            {
                gsap.to(serviceIntroduction, { opacity: 1, duration: 0.8, delay: 1.2 });
            }
        });
    }


    // Side By Side
    const sideBySideItems = document.querySelectorAll('.sideBySide__grid');

    if (sideBySideItems.length > 0)
    {
        [...sideBySideItems].forEach((element, index) => {
            const leftColumnElement = element.querySelector('.sideBySide__grid-leftColumn');
            const rightColumnElement = element.querySelector('.sideBySide__grid-rightColumn');
    
            // Left Column
            gsap.set(leftColumnElement, { opacity: 0 });
            gsap.fromTo(leftColumnElement, { opacity: 0 },
                {
                    opacity: 1,
                    ease: "power2.out",
                    duration: 1.4,
                    scrollTrigger: 
                    {
                        trigger: leftColumnElement,
                        start: "top 70%",
                        scrub: false,
                        invalidateOnRefresh: true,
                        markers: false
                    }
                }
            );
    
            // Right Column
            gsap.set(rightColumnElement, { opacity: 0 });
            gsap.fromTo(rightColumnElement, { opacity: 0 },
                {
                    opacity: 1,
                    ease: "power2.out",
                    duration: 1.4,
                    scrollTrigger: 
                    {
                        trigger: rightColumnElement,
                        start: "top 70%",
                        scrub: false,
                        invalidateOnRefresh: true,
                        markers: false
                    }
                }
            );
        });
    }


    // Video & Service Preview
    const videoItems = document.querySelectorAll('.video__figure, .videoPlayer__container, .servicePreview');

    if (videoItems.length > 0)
    {
        [...videoItems].forEach((element, index) => {
            gsap.set(element, { opacity: 0 });
            gsap.fromTo(element, { opacity: 0 },
                {
                    delay: 0.5,
                    opacity: 1,
                    ease: "power2.out",
                    duration: 1.4,
                    scrollTrigger: 
                    {
                        trigger: element,
                        start: "top 70%",
                        scrub: false,
                        invalidateOnRefresh: true,
                        markers: false
                    }
                }
            );
        });
    }
}


barba.hooks.enter((data) => {

    moduleAnimations();

});


moduleAnimations();